export class Animate {
  constructor(difference) {
    this.width = 250
    this.height = 250
    this.top = 10
    this.left = 10
    this.innerElement = "cxAnimate"
    this.imgSrc = "animate1.gif"
    this.previewSrc = "animate1.gif"
    this.rotate = 0
    this.isOnlinelRes = false
    this.animateSets = {}
    this.styleId = 1
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
